/* A shared schedule: recurring cycles advance from the configured deadline. */
function announcementCountdownState(config, now) {
  const raw = String(config.deadline || '').trim().replace(' ', 'T');
  // An explicit offset avoids different deadlines on different shoppers' devices.
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(raw)) return null;
  const firstEnd = Date.parse(raw);
  if (!Number.isFinite(firstEnd)) return null;
  const period = (Number(config.days || 0) * 24 + Number(config.hours || 0)) * 3600000;
  let end = firstEnd;
  if (config.mode === 'repeat') {
    if (!Number.isFinite(period) || period < 3600000) return null;
    if (now >= firstEnd) end += (Math.floor((now - firstEnd) / period) + 1) * period;
  }
  const seconds = Math.max(0, Math.ceil((end - now) / 1000));
  return { end, expired: now >= end, days: Math.floor(seconds / 86400), hours: Math.floor(seconds % 86400 / 3600), minutes: Math.floor(seconds % 3600 / 60), seconds: seconds % 60 };
}

if (!customElements.get('announcement-countdown')) {
  customElements.define('announcement-countdown', class extends HTMLElement {
    connectedCallback() {
      clearInterval(this.timer);
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    tick() {
      const state = announcementCountdownState(this.dataset, Date.now());
      const visible = !!state && !state.expired;
      this.hidden = !visible;
      this.closest('.announcement-bar')?.classList.toggle('has-countdown', visible);
      if (!visible) return;
      for (const unit of ['days','hours','minutes','seconds']) {
        this.querySelector('[data-unit="' + unit + '"]').textContent = String(state[unit]).padStart(2, '0');
      }
      this.querySelector('[role="timer"]').setAttribute('aria-label', `${state.days} days, ${state.hours} hours, ${state.minutes} minutes, ${state.seconds} seconds remaining`);
    }
  });
}
